<template>
	<div
		class="alert-tile"
		@click="$emit('alertTileClicked', alertType)"
		:class="{ active: active }"
	>
		<AlertTypeIcon :alertType="alertType" />
		<div class="alert-tile-info">
			<h2 class="alert-tile-title">
				{{ alertTitle
				}}<span class="alert-tile-subtitle" v-if="alertSubtitle">{{
					alertSubtitle
				}}</span>
			</h2>
			<span class="alert-tile-data">{{ alertInfo }}</span>
		</div>
	</div>
</template>

<script>
import AlertTypeIcon from './AlertTypeIcon.vue';

export default {
	name: 'AlertTile',
	components: {
		AlertTypeIcon,
	},
	props: {
		alertType: String,
		alertTitle: String,
		alertSubtitle: String,
		alertInfo: Number,
		active: Boolean,
	},
};
</script>

<style lang="scss" scoped>
.alert-tile {
	border: 1px solid $border-color-light;
	border-radius: 6px;
	background-color: $white;
	display: grid;
	grid-template-columns: 44px auto;
	cursor: pointer;
	transition: all 0.3s ease;
	@include rem('padding', 17px 18px 19px);
	@include rem('grid-gap', 15px);

	&-title {
		margin: 0;
		color: $black;
		@include rem('font-size', 16px);
	}

	&-subtitle {
		color: $text-base-color;
		@include rem('font-size', 14px);
		@include rem('margin-left', 5px);
	}

	&-data {
		color: $brand-blue;
		@include rem('font-size', 24px);
	}

	&:hover,
	&:focus,
	&.active {
		background-color: $highlight-color;
		border-color: $brand-blue;
	}
}
</style>
